import { render, staticRenderFns } from "./InvestmentInvoice.vue?vue&type=template&id=6ae0e918&scoped=true"
import script from "./InvestmentInvoice.vue?vue&type=script&lang=js"
export * from "./InvestmentInvoice.vue?vue&type=script&lang=js"
import style0 from "./InvestmentInvoice.vue?vue&type=style&index=0&id=6ae0e918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae0e918",
  null
  
)

export default component.exports